import React from 'react'

export interface UpcomingIconProps {
  size?: number
  className?: string
}

export const UpcomingIcon: React.FC<UpcomingIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.08 0.72V3.62M10.88 0.72V3.62M1.45 6.52H14.5M2.9 2.17H13.05C13.85 2.17 14.5 2.82 14.5 3.62V13.77C14.5 14.57 13.85 15.22 13.05 15.22H2.9C2.1 15.22 1.45 14.57 1.45 13.77V3.62C1.45 2.82 2.1 2.17 2.9 2.17Z"
      stroke="currentColor"
      strokeWidth="1.44638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Tab-open / active variant of UpcomingIcon — filled calendar body + colored
 * header band in the current life-space color. Uses design tokens
 * (`--space-100/--space-300/--space-700`) so the icon adapts per life space.
 */
export const UpcomingOpenIcon: React.FC<UpcomingIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.6 3.02H2.4C1.63 3.02 1 3.76 1 4.66V13.39C1 14.29 1.63 15.02 2.4 15.02H13.6C14.37 15.02 15 14.29 15 13.39V4.66C15 3.76 14.37 3.02 13.6 3.02Z"
      fill="var(--space-100, #EDE9FE)"
    />
    <path
      d="M12.8 2.02H3.2C2.54 2.02 2 2.27 2 2.57V5.48C2 5.78 2.54 6.02 3.2 6.02H12.8C13.46 6.02 14 5.78 14 5.48V2.57C14 2.27 13.46 2.02 12.8 2.02Z"
      fill="var(--space-300, #C4B5FD)"
    />
    <path
      d="M5.08 0.72V3.62M10.88 0.72V3.62M1.45 6.52H14.5M2.9 2.17H13.05C13.85 2.17 14.5 2.82 14.5 3.62V13.77C14.5 14.57 13.85 15.22 13.05 15.22H2.9C2.1 15.22 1.45 14.57 1.45 13.77V3.62C1.45 2.82 2.1 2.17 2.9 2.17Z"
      stroke="var(--space-700, #6D28D9)"
      strokeWidth="1.44638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
